import { useRef, useState } from 'react';

import { ModalDialogRef, PayrunApproversDetail } from '@xemplo/payrun-approvers-detail';
import { useGetPayrunApproversListQuery } from '@xemplo/payrun-query';
import { useServerSideState } from '@xemplo/table';

import { usePayrunApproverColumnHandler } from './payrun-approvers-list.helpers';
import * as S from './payrun-approvers-list.styles';
import { PayrunApproversListProps } from './payrun-approvers-list.types';

export const PayrunApproversListTestId = {
  container: 'payrun-approver-list-container',
};

export function PayrunApproversList({
  companyId,
  className,
}: Readonly<PayrunApproversListProps>) {
  const { pagination, onPaginationChange } = useServerSideState({
    pageIndex: 0,
    pageSize: 10,
  });
  const { pageIndex, pageSize } = pagination;
  const { data: payrunApprovers, isLoading } = useGetPayrunApproversListQuery({
    companyId,
    requestParams: {
      page: pageIndex + 1,
      per_page: pageSize,
    },
  });

  const { payrunApproversListColumns } = usePayrunApproverColumnHandler();

  const modelRef = useRef<ModalDialogRef>(null);
  const [userId, setUserId] = useState<string | undefined>();
  const [name, setName] = useState<string | null>();
  const [profilePhoto, setProfilePhoto] = useState<string | null>();

  const openPayrunApproversDetail = (
    userId?: string,
    name?: string,
    profilePhoto?: string
  ) => {
    setUserId(userId);
    setName(name);
    setProfilePhoto(profilePhoto);
    modelRef.current?.openModalDialog();
  };

  return (
    <S.PayrunApproversListContainer
      data-testid={PayrunApproversListTestId.container}
      className={className}
    >
      <S.Table
        data={payrunApprovers?.result?.rows ?? []}
        columns={payrunApproversListColumns}
        onPaginationChange={onPaginationChange}
        state={{ pagination }}
        isLoading={isLoading}
        pageCount={payrunApprovers?.result?.total_Pages ?? 0}
        enableRowSelection={false}
        enableTotals={false}
        manualPagination
        enablePagination
        totalRowCount={payrunApprovers?.result?.total ?? 0}
        onBodyRowClick={(e, row) =>
          openPayrunApproversDetail(
            row.original.userId,
            row.original.name,
            row.original.profilePhoto
          )
        }
      />
      <PayrunApproversDetail
        companyId={companyId}
        userId={userId}
        name={name}
        profilePhoto={profilePhoto}
        ref={modelRef}
      />
    </S.PayrunApproversListContainer>
  );
}

export default PayrunApproversList;
